<template>
  <div>
    <QrCodeReader
      v-if="isCameraEnabled"
      @on-detect="onReadQrCode"
      class="mx-auto mb-14 h-[185px] w-[185px]"
    />

    <TextInput
      type="number"
      ref="input"
      class="mb-8 w-full"
      :class="{
        'mt-36': !isCameraEnabled
      }"
      label="Informe o código da OP"
      @enter-key-up="handleClickSubmitButton"
      v-model="moCode"
    />

    <VButton :disabled="!moCode" type="solid" title="Enviar" :callback="handleClickSubmitButton" />
  </div>
</template>

<script setup lang="ts">
import VButton from '@/components/Button/VButton.vue'
import QrCodeReader from '@/components/QrCodeReader/QrCodeReader.vue'
import TextInput from '@/components/TextInput/TextInput.vue'
import { showDefaultToast } from '@/helpers/toast-models'
import { extractTagFromUrl } from '@/helpers/url-parser'
import { ScanInputType, useAppStore } from '@/stores/app.store'
import { computed, onMounted, ref, watch } from 'vue'
import { useFetchManufacturingOrder } from './query'

const appStore = useAppStore()

const moCode = ref('')

const { data, refetch: fetchManufacturingOrder, isError } = useFetchManufacturingOrder(moCode)

const input = ref<HTMLInputElement | null>(null)

const isCameraEnabled = computed(() => appStore.scanInputType === ScanInputType.CAMERA)

async function onReadQrCode(code: string) {
  input.value?.focus()
  const mo = extractTagFromUrl(code)

  if (mo) {
    moCode.value = mo
    await handleClickSubmitButton()
    return
  }

  showDefaultToast('Código inválido', "error")
}

async function handleClickSubmitButton() {
  await fetchManufacturingOrder()

  if (data.value && !isError.value) {
    appStore.actions.setManufacturingOrder(data.value)
  }
}

function autoFocus() {
  if (appStore.scanInputType === ScanInputType.EXTERNAL_SENSOR) {
    input.value?.focus()
  }
}

onMounted(autoFocus)

watch(() => appStore.scanInputType, autoFocus)
</script>
